import router from '@/router';

async function apiFetch(input: Parameters<typeof fetch>[0], init?: RequestInit): Promise<Response> {
  const res = await fetch(input, init);

  if (!res.ok) {
    // Clone so the original body stream stays available for the caller
    try {
      const data = await res.clone().json();
      const msg: string = data?.error?.error || data?.error || data?.message || '';
      if (msg.toLowerCase().includes('token has expired')) {
        sessionStorage.setItem('redirectPath', router.currentRoute.value.fullPath);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('permissions');
        localStorage.removeItem('purpose');
        router.push('/login?expired=true');
      }
    } catch {
      // response body was not JSON — ignore, let caller handle the error
    }
  }

  return res;
}

export default apiFetch;
